import { Form, Input, Row, Col, Switch, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../../system/WebEditUniversalNewEx';
import fetchApi from '../../../../utils/api/fetchApi';
import getList from "../../../universal/getList";

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据defaultService */
    let defaultService: any = '';

    const [wxSubscribeMessageV2TypeData, setWxSubscribeMessageV2TypeData] = useState<any>();
    const [wxSubscribeMessageNotifyTypeData, setWxSubscribeMessageNotifyTypeData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
            ref.current.row.then((res: any) => {
            })
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'wxSubscribeMessageV2Type',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setWxSubscribeMessageV2TypeData(res.data);
                    }
                })
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'wxSubscribeMessageNotifyType',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setWxSubscribeMessageNotifyTypeData(res.data);
                    }
                })
        }
        fetchData();
    }, []);

    const onSelectHandle = (e: any) => {
        form.setFieldValue('typeName', e.children);
    }

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'wxSubscribeMessageV2Type',
        serviceId: 'business'
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '微信订阅信息V2类型'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                // onKeyPress={(e: any) => {
                //     if (e.key === 'Enter') {
                //         handleOk(e)
                //     }
                // }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="类型"
                                name="id"
                                rules={[{ required: true, message: '类型!' }]}>
                                <Select
                                    disabled={data.type === 'NEW' ? false : true}
                                    showSearch
                                    placeholder="id"
                                    optionFilterProp="children"
                                    onSelect={(_key, e) => onSelectHandle(e)}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(wxSubscribeMessageV2TypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="名称"
                                name="typeName">
                                <Input disabled={true} placeholder="typeName" />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="卡片id"
                                name="notifyType"
                                rules={[{ required: true, message: '卡片id!' }]}>
                                <Select
                                    showSearch
                                    placeholder="notifyType"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(wxSubscribeMessageNotifyTypeData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="小程序跳转路径"
                                name="wxa_path_query">
                                <Input placeholder="wxa_path_query" />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebEdit;